import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ErrorBoundary from "@/components/ErrorBoundary";
import HomePage from "@/pages/HomePage";
import HomePageGrid from "@/pages/HomePageGrid";
import CreateListingPage from "@/pages/CreateListingPage";
import ListingDetailPage from "@/pages/ListingDetailPage";
import EditListingPage from "@/pages/EditListingPage";
import FavoritesPage from "@/pages/FavoritesPage";
import ClubFittingGuidePage from "@/pages/ClubFittingGuidePage";
import WedgeGrindGuidePage from "@/pages/WedgeGrindGuidePage";
import EquipmentGuidePage from "@/pages/EquipmentGuidePage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminPage from "@/pages/AdminPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import AuthCallback from "@/pages/AuthCallback";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import BottomNav from "@/components/layout/BottomNav";
import { Toaster } from "@/components/ui/sonner";

// Router component that handles auth callback detection
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id - must be synchronous during render
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <>
      <Routes>
        <Route path="/" element={<HomePageGrid />} />
        <Route path="/original" element={<HomePage />} />
        <Route path="/create" element={<CreateListingPage />} />
        <Route path="/listing/:id" element={<ListingDetailPage />} />
        <Route path="/edit/:id" element={<EditListingPage />} />
        <Route path="/favorites" element={<FavoritesPage />} />
        <Route path="/club-fitting-guide" element={<ClubFittingGuidePage />} />
        <Route path="/wedge-grind-guide" element={<WedgeGrindGuidePage />} />
        <Route path="/utstyrsguide" element={<EquipmentGuidePage />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
      </Routes>
      <BottomNav />
    </>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <div className="App">
          <Toaster position="top-right" />
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </div>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;